/**
 * La configuration d'exécution du site.
 *
 * Elle n'est **pas** compilée dans le bundle : elle arrive par `/config.json`,
 * écrit au déploiement à partir des sorties de la pile (`Source.jsonData`). Un
 * seul artefact de build vaut donc pour toutes les piles, et changer d'API ne
 * demande pas de reconstruire le site.
 *
 * Le fichier est servi par la **même origine** que le site, donc sans CORS et
 * sans jeton : il ne contient que des identifiants publics — ceux qu'un client
 * OAuth public expose de toute façon dans son URL d'autorisation.
 */
export interface RuntimeConfig {
  /** Racine de l'HTTP API, sans barre oblique finale. */
  readonly apiUrl: string;
  readonly region: string;
  readonly userPoolId: string;
  readonly appClientId: string;
  /** Domaine du managed login Cognito, sans schéma. */
  readonly authDomain: string;
}

let cached: RuntimeConfig | undefined;

export async function loadConfig(): Promise<RuntimeConfig> {
  if (cached) return cached;

  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`configuration illisible : ${res.status}`);
  }
  const raw = (await res.json()) as Partial<RuntimeConfig>;

  // Un champ manquant produirait plus loin une URL d'autorisation
  // silencieusement fausse, et une redirection vers une page d'erreur Cognito
  // sans indice. Autant échouer ici, avec le nom du champ.
  for (const key of ['apiUrl', 'region', 'userPoolId', 'appClientId', 'authDomain'] as const) {
    if (!raw[key]) throw new Error(`configuration incomplète : ${key} manquant`);
  }

  cached = {
    apiUrl: raw.apiUrl!.replace(/\/+$/, ''),
    region: raw.region!,
    userPoolId: raw.userPoolId!,
    appClientId: raw.appClientId!,
    authDomain: raw.authDomain!.replace(/^https?:\/\//, '').replace(/\/+$/, ''),
  };
  return cached;
}
